"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _Link = _interopRequireDefault(require("./Link"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(e, r) { return new BabelRegExp(e, void 0, r); }; var e = RegExp.prototype, r = new WeakMap(); function BabelRegExp(e, t, p) { var o = new RegExp(e, t); return r.set(o, p || r.get(e)), _setPrototypeOf(o, BabelRegExp.prototype); } function buildGroups(e, t) { var p = r.get(t); return Object.keys(p).reduce(function (r, t) { var o = p[t]; if ("number" == typeof o) r[t] = e[o];else { for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length;) { i++; } r[t] = e[o[i]]; } return r; }, Object.create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (r) { var t = e.exec.call(this, r); if (t) { t.groups = buildGroups(t, this); var p = t.indices; p && (p.groups = buildGroups(p, this)); } return t; }, BabelRegExp.prototype[Symbol.replace] = function (t, p) { if ("string" == typeof p) { var o = r.get(this); return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)>/g, function (e, r) { var t = o[r]; return "$" + (Array.isArray(t) ? t.join("$") : t); })); } if ("function" == typeof p) { var i = this; return e[Symbol.replace].call(this, t, function () { var e = arguments; return "object" != _typeof(e[e.length - 1]) && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e); }); } return e[Symbol.replace].call(this, t, p); }, _wrapRegExp.apply(this, arguments); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var PriceModelV1Link = function PriceModelV1Link(_ref) {
  var locale = _ref.locale,
    i18n = _ref.i18n,
    links = _ref.links,
    inline = _ref.inline;
  var priceModelLink = null;
  if (links.priceModel) {
    // eslint-disable-next-line
    var publishedPriceModelInfo = links.priceModel.href.match( /*#__PURE__*/_wrapRegExp(/.*productprice.*\/priceModels\/(.*)\/revisions\/([0-9]*)/, {
      id: 1,
      revision: 2
    }));
    // eslint-disable-next-line
    var unpublishedPriceModelInfo = links.priceModel.href.match( /*#__PURE__*/_wrapRegExp(/.*productprice.*\/priceModels\/(.*)/, {
      id: 1
    }));
    if (publishedPriceModelInfo) {
      var revision = publishedPriceModelInfo.groups['revision'];
      var id = publishedPriceModelInfo.groups['id'];
      priceModelLink = "https://pricingmanager.ff.cimpress.io/models/".concat(id, "?revision=").concat(revision);
    } else if (unpublishedPriceModelInfo) {
      var _id = unpublishedPriceModelInfo.groups['id'];
      // If there's no revision, this price was calculated using an unpublished price model (i.e. legacy contract)
      priceModelLink = "https://pricingmanager.ff.cimpress.io/models/".concat(_id);
    } else {
      // If there's no revision or id, it means this is a price model from shipping price
      // Which has no UX to view it, so just surface the link
      priceModelLink = links.priceModel.href;
    }
  }
  return priceModelLink === null ? null : /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    locale: locale,
    i18n: i18n,
    href: priceModelLink,
    translationsKey: "view_pricing",
    inline: inline
  });
};
PriceModelV1Link.propTypes = {
  locale: _propTypes["default"].string,
  i18n: _propTypes["default"].any,
  // comes from withTranslation
  inline: _propTypes["default"].bool,
  links: _propTypes["default"].object
};
var _default = (0, _reactI18next.withTranslation)()(PriceModelV1Link);
exports["default"] = _default;